// extracted by mini-css-extract-plugin
module.exports = {"head":"Header_head__3iMXe","logo":"Header_logo__30C5C","icon":"Header_icon__FaPhu","link_container":"Header_link_container__BME8q","link":"Header_link__30HfS"};